import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-723c6d85"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "export-empty-tip"
}

import { computed, reactive, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import type { FormInstance, Rule } from 'ant-design-vue/es/form';
import {
  createExportTask,
  queryExportTemplates,
  RECEIVABLE_MANAGE_EXPORT_MODEL,
  type ExcelWorkbookDefinitionItem,
} from './index';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportDialog',
  props: {
    visible: { type: Boolean },
    masterIdList: null,
    queryData: null,
    model: null,
    path: null
  },
  emits: ["update:visible", "success"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void;
  (e: 'success'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean;
  /** 勾选行的 masterId（列表隐藏字段，导出传 masterIdList） */
  masterIdList?: string[];
  /** 未勾选时传入当前列表筛选条件 */
  queryData?: Record<string, unknown>;
  model?: string;
  /** 导出请求 variables.path；不传则不带 path（客户/历史归档） */
  path?: string;
}





const loading = ref(false);
const submitting = ref(false);
const formRef = ref<FormInstance>();
const templates = ref<ExcelWorkbookDefinitionItem[]>([]);

const form = reactive({
  selectedTemplateId: undefined as string | undefined,
});

/** 对齐设计器：字段下方红字「必填」 */
const formRules: Record<string, Rule[]> = {
  selectedTemplateId: [{ required: true, message: '必填', trigger: 'change' }],
};

const templateOptions = computed(() =>
  templates.value.map((item) => ({
    value: item.id,
    label: item.displayName || item.id,
  })),
);

function filterTemplateOption(input: string, option?: { label?: string }) {
  const keyword = input.trim().toLowerCase();
  if (!keyword) return true;
  return String(option?.label ?? '')
    .toLowerCase()
    .includes(keyword);
}

function showApiError(error: unknown, fallback: string) {
  const content = error instanceof Error ? error.message : fallback;
  message.error({
    content,
    class: 'receivable-api-error-msg',
    duration: 5,
  });
}

async function loadTemplates() {
  loading.value = true;
  form.selectedTemplateId = undefined;
  templates.value = [];
  formRef.value?.clearValidate();
  try {
    templates.value = await queryExportTemplates(
      props.model || RECEIVABLE_MANAGE_EXPORT_MODEL,
    );
    if (templates.value.length === 1) {
      form.selectedTemplateId = templates.value[0].id;
    }
  } catch (error) {
    showApiError(error, '查询导出模板失败');
  } finally {
    loading.value = false;
  }
}

watch(
  () => props.visible,
  (open) => {
    if (open) loadTemplates();
  },
);

function handleCancel() {
  emit('update:visible', false);
}

async function handleExport() {
  try {
    await formRef.value?.validate();
  } catch {
    message.error('导出模板 必填');
    return Promise.reject();
  }

  submitting.value = true;
  try {
    const masterIdList = (props.masterIdList ?? [])
      .map((id) => String(id).trim())
      .filter(Boolean);
    await createExportTask({
      workbookDefinitionId: form.selectedTemplateId!,
      masterIdList,
      queryData: props.queryData,
      model: props.model || RECEIVABLE_MANAGE_EXPORT_MODEL,
      path: props.path,
    });

    // 异步导出任务：不下载文件，关闭弹窗并提示成功（用户到「导出任务」自行下载）
    emit('success');
    emit('update:visible', false);
    message.success({
      content: '导出成功',
      class: 'receivable-export-success-msg',
      duration: 3,
    });
  } catch (error) {
    showApiError(error, '导出失败');
    return Promise.reject();
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: __props.visible,
    title: "导出",
    width: 480,
    "confirm-loading": submitting.value,
    "mask-closable": false,
    "destroy-on-close": "",
    "wrap-class-name": "export-dialog-modal",
    "ok-text": "导出",
    "cancel-text": "取消",
    onOk: handleExport,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_spin, { spinning: loading.value }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref_key: "formRef",
            ref: formRef,
            layout: "vertical",
            class: "export-dialog-form",
            model: form,
            rules: formRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                label: "导出模板",
                name: "selectedTemplateId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: form.selectedTemplateId,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.selectedTemplateId) = $event)),
                    "show-search": "",
                    "allow-clear": "",
                    placeholder: "导出模板",
                    options: _unref(templateOptions),
                    "filter-option": filterTemplateOption,
                    style: {"width":"100%"}
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }),
              (!loading.value && _unref(templateOptions).length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, " 暂无可用导出模板，请先在后台配置后再试 "))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["spinning"])
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading"]))
}
}

})